import { render, staticRenderFns } from "./Karin-form.vue?vue&type=template&id=09981111&scoped=true"
import script from "./Karin-form.vue?vue&type=script&lang=js"
export * from "./Karin-form.vue?vue&type=script&lang=js"
import style0 from "./Karin-form.vue?vue&type=style&index=0&id=09981111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09981111",
  null
  
)

export default component.exports